<div class="m-b-md">
    <div class="form-group" *ngIf="data.paymentMethod">
        <strong>Payment Method</strong> : {{data.paymentMethod == 'credit_card' ? creditCardNumbersString : paymentMethods[data.paymentMethod]}}
    </div>
    <div class="list-payments">
        <div [ngStyle]="{'display': paidFee.active ? '' : 'none'}" *ngFor="let paidFee of amenityFees let index = index">
            <div *ngIf="paidFee.include" class="row m-b-sm">
                <div class="col-xs-5 col-md-5">
                    <strong class="text-capitalize">{{paidFee.name}}</strong>
                </div>
                <div class="col-xs-3 col-sm-3">
                    <span *ngIf="!paidFee.waived">{{paidFee.status ? 'Paid' : 'Not Paid'}}</span>
                    <span *ngIf="paidFee.waived">Waived</span>
                </div>
                <div class="col-xs-3 col-md-3 fourteenPixelText">
                    <span *ngIf="paidFee.pmtAtTime && getStartEndDayDifference() > 1">
                        {{getStartEndDayDifference() + ' x '}}
                    </span>
                    <span *ngIf="paidFee.pmtHourly && getStartEndHourDifference() > 1">
                        {{getStartEndHourDifference() + ' x '}}
                    </span>
                    <span>{{paidFee.amount | currency}}</span>
                </div>
                <div *ngIf="!paidFee.status && !paidFee.waived && data.paymentMethod != 'credit_card' &&
                            !authService.userIsResident && amenitiesService.amenityInAmenityModal.isCanEdit"
                     class="col-xs-1 col-md-1"
                     style="padding: 0; cursor: pointer;">
                    <span class="mtv-primary-color" (click)="payFee(paidFee)">PAY</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getTotalRefundableValue() != '0.00'">
        <div class="col-xs-9 col-md-9">
            <label>Total Refundable</label>
        </div>
        <div class="col-xs-3 col-md-3 mtv-primary-color">
            {{'$' + getTotalRefundableValue()}}
        </div>
    </div>

    <div class="row m-b-sm sixteen-pixel-bold"
         *ngIf="getReservationProcessingFeeValue() != '0.00' && data.paymentMethod == 'credit_card'">
        <div class="col-xs-9 col-md-9">
            <label>Reservation Processing Fee</label>
        </div>
        <div class="col-xs-3 col-md-3 mtv-primary-color">
            {{'$' + getReservationProcessingFeeValue()}}
        </div>
    </div>

    <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getTotalCharged() != '0.00'">
        <div class="col-xs-9 col-md-9">
            <label>Total Payment Due</label>
        </div>
        <div class="col-xs-3 col-md-3 mtv-primary-color">
            {{'$' + getTotalCharged()}}
        </div>
    </div>
    <spinner [spinnerShow]="showTimeSelectSpinner"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-payments/amenities-payments.component.html